import { useState } from 'react';
import useAuthStore from '../stores/authStore';
import { Eye, EyeOff, LogIn } from 'lucide-react';

function formatApiError(detail) {
  if (detail == null) return 'Algo salió mal. Intenta de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function LoginPage() {
  const login = useAuthStore(s => s.login);
  const forcedLogoutReason = useAuthStore(s => s.forcedLogoutReason);
  const clearForcedLogoutReason = useAuthStore(s => s.clearForcedLogoutReason);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    clearForcedLogoutReason();
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <img src="/assets/logo-kompa.png" alt="KOMPA" className="login-logo h-12 w-auto object-contain" />
          <p className="login-subtitle">GESTION DE RELACIONES CON EL CLIENTE</p>
        </div>
        <div className="login-visual">
          <div className="login-dots" />
        </div>
      </div>
      <div className="login-right">
        <form data-testid="login-form" onSubmit={handleSubmit} className="login-form">
          <div className="login-form-header">
            <img src="/assets/logo-k-claro.png" alt="K" className="login-k-icon h-20 w-auto object-contain" />
            <h1>Iniciar Sesión</h1>
            <p>Accede a tu CRM KOMPA 2.0</p>
          </div>
          {forcedLogoutReason && !error && (
            <div data-testid="login-forced-logout" className="login-error login-warning">
              {forcedLogoutReason}
            </div>
          )}
          {error && <div data-testid="login-error" className="login-error">{error}</div>}
          <div className="form-group">
            <label>Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="tu@kompa.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <div className="input-with-icon">
              <input
                data-testid="login-password-input"
                type={show ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
              <button type="button" className="toggle-pass" onClick={() => setShow(!show)}>
                {show ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button data-testid="login-submit-button" type="submit" disabled={loading} className="login-btn">
            {loading ? <span className="spinner" /> : <><LogIn size={18} /> Entrar</>}
          </button>
        </form>
      </div>
    </div>
  );
}
